import { useCustomMutation } from '../../graphql';
import { useQueryClient } from '@tanstack/react-query';
import { useInvalidateConfig } from '../../hooks';
import { useAccessTokenReceived } from './useAccessTokenReceived';
import { useGrippContext } from '../../grippContext';
import { useStorageKeys } from '../../storage';

export const useImpersonateUser = () => {
  const { mutateAsync, isPending } = useCustomMutation({
    query: IMPERSONATE_USER,
  });
  const onAccessTokenReceived = useAccessTokenReceived();
  const queryClient = useQueryClient();
  const invalidateConfig = useInvalidateConfig();
  const { secureStorageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  return {
    impersonateUserAsync: async (
      input: any,
      onSettled: () => void,
      onRegister: () => void = () => null
    ) => {
      const existingOldToken = await secureStorageHandler.getItem(
        storageKeys.oldAccessToken
      );
      if (existingOldToken) {
        await onAccessTokenReceived('', true, false);
      }

      await mutateAsync(
        { input },
        {
          onSettled: async (data: any) => {
            if (data?.authentication?.impersonateUser?.success) {
              await onAccessTokenReceived(
                data?.authentication?.impersonateUser?.accessToken
              );
              await invalidateConfig();
              await queryClient.invalidateQueries({
                queryKey: ['currentAccount'],
              });

              onSettled();
            }

            return;
          },
        }
      );
    },
  };
};

const IMPERSONATE_USER = `
  mutation Authentication($input: ImpersonateUserInput!) {
    authentication {
      impersonateUser(input: $input) {        
        success
        message
        accessToken
      }
    }
  }
`;
